module.exports = __webpack_public_path__ + "static/media/laffah.802161bb.png";